import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-gardiennage-chantier-service',
  imports: [RouterLink],
  templateUrl: './gardiennage-chantier-service.html',
  styleUrl: './gardiennage-chantier-service.scss',
})
export class GardiennageChantierService {

}
